module.exports = __webpack_public_path__ + "img/HUSH.f1a4a684.svg";